'use strict';

const TaxSchedule = require('../config/taxschedule.json');
const enumtype = require('../config/constants.js');
const PROV = enumtype.PROV;
let salesTax = TaxSchedule;
/*The extraction of json data from root element. else will be taken from hardcoded json*/
if (document.getElementById('root')) {
  let taxProps = JSON.parse(document.getElementById('root').getAttribute('data-salestax-json'));
  if (taxProps) salesTax = taxProps;
}
let SalesTax = salesTax;

function simpleTaxAmount(taxOpt) {
  let taxable = taxOpt.amount;
  let taxschedule = '';

  taxschedule = SalesTax.taxSchedule.filter(function (val) {
    return taxOpt.province == val.province;
  });
  //BC tiered salestax calculation
  if (taxOpt.amountForBC && taxOpt.province == PROV.BC) {
    //if electric then consider evceiling
    const isElectric = taxOpt.vehicleType === 'Electric';
    let tier = taxschedule[0].rateTiers
      .filter(function (val) {
        return isElectric ? taxOpt.amountForBC <= val.evceiling : taxOpt.amountForBC <= val.ceiling;
      })
      .sort(function (a, b) {
        // reverse sort rate tiers
        return b.ordinal - a.ordinal;
      })
      .pop();
    // lowest matching tier
    taxschedule[0].salestax.find(function (val) {
      return val.name == 'PST';
    }).rate = tier.rate;
    // update provincial tax rate
  }
  let taxamount = taxschedule[0].salestax.reduce(function (a, b) {
    return a + taxable * b.rate;
  }, 0);

  return {
    province: taxOpt.province,
    taxRate: taxamount / taxable,
    taxAmount: taxamount,
    salesTotal: taxable + taxamount,
  };
}

function taxCalc(taxOpt) {
  return taxOpt.mode && taxOpt.mode.toUpperCase() === 'SIMPLE' ? simpleTaxAmount(taxOpt) : '';
}

function getTaxRate(taxOpt) {
  let taxschedule = SalesTax.taxSchedule.filter(function (val) {
    return taxOpt.province == val.province;
  });

  //BC tiered salestax calculation
  if (taxOpt.amountForBC && taxOpt.province == PROV.BC) {
    //if electric then consider evceiling
    const isElectric = taxOpt.vehicleType === 'Electric';
    let tier = taxschedule[0].rateTiers
      .filter(function (val) {
        return isElectric ? taxOpt.amountForBC <= val.evceiling : taxOpt.amountForBC <= val.ceiling;
      })
      .sort(function (a, b) {
        // reverse sort rate tiers
        return b.ordinal - a.ordinal;
      })
      .pop();
    // lowest matching tier
    taxschedule[0].salestax.find(function (val) {
      return val.name == 'PST';
    }).rate = tier.rate;
    // update provincial tax rate
  }
  let rate = taxschedule[0].salestax.reduce(function (a, b) {
    return a + b.rate;
  }, 0);
  //tradeInIncluded will be available only if lease and province = BC
  if (taxOpt.tradeInIncluded) {
    const pstTax = taxschedule[0].salestax.filter(function (tax) {
      return tax.name === 'PST';
    });
    rate = pstTax[0].rate;
  }

  return rate;
}

function calculateTaxableAmount(taxOpt) {
  let rate = getTaxRate(taxOpt);
  let taxable = taxOpt.amount;

  return {
    province: taxOpt.province,
    taxRate: rate,
    taxableAmount: taxable,
    salesTax: taxable * rate,
  };
}

function getLuxuryTax(price) {
  let taxAmount = 0;
  if (price > SalesTax.luxuryTaxThreshold) {
    const minRateTax = price * (SalesTax.luxuryTaxMinRate / 100);
    const maxRateTax = (price - SalesTax.luxuryTaxThreshold) * (SalesTax.luxuryTaxMaxRate / 100);
    taxAmount = maxRateTax >= minRateTax ? minRateTax : maxRateTax;
  }
  return taxAmount;
}

module.exports = {
  calc: taxCalc,
  calculateTaxableAmount: calculateTaxableAmount,
  getLuxuryTax: getLuxuryTax,
};
